import axios from "axios";
import { API_BASE_URL } from "config";
import { useMutation } from "react-query";

const handleLikeDislike = async ({ type, answer_type, id, sources }) => {
  const authToken = localStorage.getItem("authToken");
  const params = new URLSearchParams(window.location.search);
  const nudgeFlow = params.get("nf");
  // let finalSource = nudgeFlow == "true" ? "nudge" : source == "service" ? "service" : "ABCD";
  const urlParams = params.get("source");

  let finalSource =
    sources === "service" || urlParams === "service"
      ? "service"
      : (nudgeFlow === "true" && sources === "nudge") || urlParams === "nudge"
        ? "nudge"
        : nudgeFlow === "true" && sources === "nudge_qna"
          ? "nudge_qna"
          : "ABCD";

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${API_BASE_URL}/feedback`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    data: {
      type,
      response_type: answer_type,
      id,
      source: finalSource,
    },
  };
  try {
    const { data } = await axios.request(config);
    return data;
  } catch (error) {
    return {
      message: "Something Went Wrong! Please Try Again Later",
    };
  }
};

const useLikeDislike = () => {
  return useMutation(handleLikeDislike, {
    onSuccess: (data) => {},
    onError: (error) => {
      console.log("Error: ", error);
    },
  });
};

export default useLikeDislike;
